import React from 'react';

export const isSingleAgreementCheckbox = (field) => {
  if (!field || field.type !== 'checkbox') return false;

  if (
    field.singleCheckbox === true ||
    field.singleCheckbox === 1 ||
    field.singleCheckbox === 'true' ||
    field.singleCheckbox === '1' ||
    field.checkboxMode === 'single' ||
    field.checkboxMode === 'agreement'
  ) {
    return true;
  }

  const hasAgreementText = !!(field.agreementText && String(field.agreementText).trim());
  const noOptions = !Array.isArray(field.options) || field.options.length === 0;
  return hasAgreementText && noOptions;
};

export const getAgreementText = (field) => {
  return field?.agreementText || field?.label || 'I agree to the terms and conditions';
};

export const normalizeCheckboxField = (field) => {
  if (!field || field.type !== 'checkbox') return field;

  const singleCheckbox = isSingleAgreementCheckbox(field);
  return {
    ...field,
    singleCheckbox,
    checkboxMode: singleCheckbox ? 'single' : 'multi',
    agreementText: singleCheckbox ? getAgreementText(field) : field.agreementText,
    options: singleCheckbox
      ? []
      : (Array.isArray(field.options) && field.options.length > 0 ? field.options : ['Option 1', 'Option 2']),
  };
};

export const normalizeFormStructure = (structure) => {
  if (!Array.isArray(structure)) return structure;

  return structure.map((field) => {
    const normalized = normalizeCheckboxField(field);
    if (field?.type === 'repeatable' && Array.isArray(field.repeatableFields)) {
      return {
        ...normalized,
        repeatableFields: field.repeatableFields.map(normalizeCheckboxField),
      };
    }
    return normalized;
  });
};

export function AgreementCheckboxField({ field, checked, onChange, error }) {
  const agreementText = getAgreementText(field);

  return (
    <div style={{ width: '100%' }}>
      <label
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
          cursor: 'pointer',
          width: '100%',
          margin: 0,
          paddingTop: '4px',
          fontFamily: field.fontFamily && field.fontFamily !== 'default' ? field.fontFamily : 'inherit',
          fontWeight: field.bold ? '700' : 'normal',
          fontStyle: field.italic ? 'italic' : 'normal',
        }}
      >
        <input
          type="checkbox"
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
          style={{
            width: '22px',
            height: '22px',
            minWidth: '22px',
            minHeight: '22px',
            marginTop: '2px',
            flexShrink: 0,
            accentColor: '#3b82f6',
            cursor: 'pointer',
            opacity: 1,
          }}
        />
        <span
          style={{
            flex: 1,
            fontSize: '16px',
            color: '#374151',
            lineHeight: 1.5,
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {agreementText}
          {field.required && <span style={{ color: '#ef4444' }}> *</span>}
        </span>
      </label>
      {error && (
        <div style={{ color: '#ef4444', fontSize: '14px', marginTop: '6px' }}>
          {error}
        </div>
      )}
    </div>
  );
}
